import React, { forwardRef } from 'react'
import { Avatar as MaterialAvatar } from '@mui/material'
import QAPIcon from 'components/atoms/corporationIcon/QAPIcon'
import { styled } from '@mui/material/styles'
import { getUserInitials, getUserColor } from 'utilities/user'
import QAPVars from 'qap/vars'
import type { User } from 'types'

type Size = 'small' | 'tiny'

interface AvatarProps {
  disabled?: boolean
  size?: Size
  user: User | null
  [key: string]: unknown
}

const StyledAvatar = styled(MaterialAvatar, {
  shouldForwardProp: (prop) => !['size', 'disabled', 'userColor'].includes(prop as string),
})<{
  size?: Size
  disabled: boolean
  userColor: string
}>(({ theme, size, disabled, userColor }) => ({
  ...(size === 'small' && {
    width: theme.spacing(4),
    height: theme.spacing(4),
    fontSize: 12,
  }),
  ...(size === 'tiny' && {
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: 10,
  }),
  backgroundColor: disabled ? QAPVars.black26 : userColor,
}))

const Avatar = forwardRef<HTMLDivElement, AvatarProps>(
  function AvatarComponent({ disabled = false, size, user, ...props }, ref) {
    const initials = getUserInitials(user?.firstName, user?.lastName)

    return (
      <StyledAvatar
        ref={ref}
        size={size}
        disabled={disabled}
        userColor={getUserColor(user?.id)}
        {...props}
      >
        {initials || <QAPIcon />}
      </StyledAvatar>
    )
  }
)

export default Avatar
